"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionUpdateConflictError = void 0;
class CollectionUpdateConflictError extends Error {
    constructor(collectionId) {
        super(`There was a conflict when trying to update collection ${collectionId}`);
        this.isUpdateConflict = true;
    }
}
exports.CollectionUpdateConflictError = CollectionUpdateConflictError;
//# sourceMappingURL=CollectionUpdateConflictError.js.map